(() => {
  document.querySelectorAll('[data-variant]').forEach(select=>select.addEventListener('change',()=>{const price=select.closest('.product-detail').querySelector('[data-product-price]');if(price)price.textContent=select.selectedOptions[0].dataset.price;}));
  document.addEventListener('click',event=>{
    const reset=event.target.closest('[data-reset-contact]');
    if(!reset)return;
    const form=reset.closest('form');
    if(!form)return;
    form.reset();
    form.querySelectorAll('input[name^="contact["], textarea[name^="contact["]').forEach(field=>{
      if(field.type==='checkbox'||field.type==='radio')field.checked=false;
      else field.value='';
    });
    form.querySelectorAll('select[name^="contact["]').forEach(select=>{select.selectedIndex=0;});
    form.querySelectorAll('[data-contact-summary]').forEach(field=>{
      field.value='';
      const wrap=field.closest('[data-summary-wrap]');
      if(wrap)wrap.hidden=true;
    });
  });
  document.addEventListener('click',e=>{const open=e.target.closest('[data-open-legal]');if(open){const dialog=document.querySelector('[data-legal-dialog="'+open.dataset.openLegal+'"]');if(dialog)dialog.showModal();}const close=e.target.closest('[data-close-legal]');if(close)close.closest('dialog').close();});
  document.querySelectorAll('[data-legal-dialog]').forEach(dialog=>dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}));

    function initVehicleDesigner(root) {
          if (root.dataset.ready === 'true') return;
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const type = root.querySelector('[data-vehicle-type]');
    const scope = root.querySelector('[data-vehicle-scope]');
    const name = root.querySelector('[data-vehicle-name]');
    const price = root.querySelector('[data-vehicle-price]');
    const request = root.querySelector('[data-vehicle-request]');
    const preview = root.querySelector('[data-vehicle-preview-name]');
    if (!type || !scope || !name || !price || !request || !preview) return;
    const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const update = () => {
  const packageChoice = scope.selectedOptions[0];
  price.textContent = packageChoice.dataset.factor === '0'
    ? 'Individuelles Angebot nach Prüfung'
    : 'Preis nach persönlicher Kalkulation';
      preview.textContent = name.value.trim().slice(0, 30) || 'DEIN LOGO';
    };
    const summary = () => 'Fahrzeugbeschriftung (Mockup)\nFahrzeugtyp: ' + type.value + '\nUmfang: ' + scope.value + '\nFirmenname für die Vorschau: ' + (name.value.trim() || 'noch offen') + '\nPreisorientierung: ' + price.textContent + '\nBitte konkreten Preis nach Fahrzeugmodell, Fotos, Maßen, Folie und Montage erstellen.';
    type.addEventListener('change', update);
    scope.addEventListener('change', update);
    name.addEventListener('input', update);
    request.addEventListener('click', () => {
      update();
      const url = new URL(request.href, window.location.origin);
      url.searchParams.set('fahrzeugkonfiguration', summary());
      request.href = url.pathname + url.search + url.hash;
    });
    update();
  }
  document.querySelectorAll('[data-pdm-vehicle]').forEach(initVehicleDesigner);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pdm-vehicle]').forEach(initVehicleDesigner));
  const vehicleConfiguration = new URLSearchParams(window.location.search).get('fahrzeugkonfiguration');
  if (vehicleConfiguration) {
    const contactSummary = document.querySelector('[data-contact-summary]');
    if (contactSummary) {
      contactSummary.value = vehicleConfiguration;
      contactSummary.closest('[data-summary-wrap]').hidden = false;
    }
    const projectType = document.querySelector('select[name="contact[Projektart]"]');
    if (projectType) projectType.value = 'Fahrzeugbeschriftung';
  }

function focusSuccessfulContact() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const message = document.querySelector('[data-contact-success]');
    if (!message) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    requestAnimationFrame(() => {
      message.scrollIntoView({ behavior, block: 'center' });
      message.focus({ preventScroll: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusSuccessfulContact, { once: true });
  } else {
    focusSuccessfulContact();
  }
})();

(() => {
  const initPlotterBackdrop = () => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.pdm-plotter-scene--home').forEach(scene => {
      if (scene.dataset.plotterReady) return;
      scene.dataset.plotterReady = 'true';
      const cue = scene.querySelector('[data-plotter-cue]');
      if (!cue) return;
      scene.classList.add('pdm-plotter-scene--motion');
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        scene.classList.add('is-cutting');
        observer.disconnect();
      }, { threshold: .15, rootMargin: '0px 0px -12% 0px' });
      observer.observe(cue);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPlotterBackdrop, { once: true });
  else initPlotterBackdrop();
})();
